import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Theme } from 'src/app/theme/theme';

interface AlertDialogData {
  theme: Theme;
  description: string;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false
})
export class AlertDialogComponent {
  data = inject<AlertDialogData>(MAT_DIALOG_DATA);
}
